import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import { messages } from '../messages';

export enum SearchPinKeyphraseErrorState {
	KEY_PHRASE_COLLISION = 'KEY_PHRASE_COLLISION',
	KEY_PHRASE_TOO_LONG = 'KEY_PHRASE_TOO_LONG',
	KEY_PHRASE_HAS_SPECIAL_CHAR = 'KEY_PHRASE_HAS_SPECIAL_CHAR',
	KEY_PHRASE_LIST_TOO_LONG = 'KEY_PHRASE_LIST_TOO_LONG',
	KEY_PHRASE_LIST_TOO_SHORT = 'KEY_PHRASE_LIST_TOO_SHORT',
	KEY_PHRASE_LIST_NON_UNIQUE = 'KEY_PHRASE_LIST_NON_UNIQUE',
}

export const getKeyPhraseErrMessage = (
	keyPhraseErrorState: SearchPinKeyphraseErrorState,
	collidedKeyPhrases: string,
	numCollidedKeyPhrases: number,
): React.JSX.Element => {
	switch (keyPhraseErrorState) {
		case SearchPinKeyphraseErrorState.KEY_PHRASE_COLLISION:
			return (
				<FormattedMessage
					{...messages.pinPhraseCollisionErr}
					values={{ keyPhrases: collidedKeyPhrases, numKeyPhrases: numCollidedKeyPhrases }}
				/>
			);
		case SearchPinKeyphraseErrorState.KEY_PHRASE_TOO_LONG:
			return <FormattedMessage {...messages.pinKeyPhraseTooLongErr} />;
		case SearchPinKeyphraseErrorState.KEY_PHRASE_HAS_SPECIAL_CHAR:
			return <FormattedMessage {...messages.pinKeyPhraseHasSpecialCharErr} />;
		case SearchPinKeyphraseErrorState.KEY_PHRASE_LIST_NON_UNIQUE:
			return <FormattedMessage {...messages.pinKeyPhraseListNonUniqueErr} />;
		case SearchPinKeyphraseErrorState.KEY_PHRASE_LIST_TOO_LONG:
			return <FormattedMessage {...messages.pinKeyPhraseListTooLongErr} />;
		case SearchPinKeyphraseErrorState.KEY_PHRASE_LIST_TOO_SHORT:
		default:
			return <FormattedMessage {...messages.pinKeyPhraseListTooShortErr} />;
	}
};

export const getCollidedKeyPhrases = (mutationErrors: any[]): string[] => {
	const collidedKeyPhrases: string[] = [];
	mutationErrors.forEach((err) => {
		if (
			err.extensions?.bookmarkFailureMetadata &&
			err.extensions.bookmarkFailureMetadata.errorType ===
				SearchPinKeyphraseErrorState.KEY_PHRASE_COLLISION
		) {
			collidedKeyPhrases.push(err.extensions.bookmarkFailureMetadata.keyPhrase);
		}
	});

	return collidedKeyPhrases;
};

export const isValidHttpUrl = (str: string): boolean => {
	let givenURL: URL;
	try {
		givenURL = new URL(str);
	} catch (error) {
		return false;
	}
	return givenURL.protocol === 'http:' || givenURL.protocol === 'https:';
};
